'use strict';

var _reactIntl = require('react-intl');

var messages = (0, _reactIntl.defineMessages)({
  editMe: {
    'id': 'TestComponent.electrodeio.editMe',
    'defaultMessage': 'Edit me!'
  }
});

module.exports = messages;


// WEBPACK FOOTER //
// ./components/footer/lib/lang/tenants/electrodeio/default-messages.js